import { faBullhorn } from "@fortawesome/pro-regular-svg-icons";
import i18n from "i18next";
import { showErrorReportDialog } from "src/sentry/showErrorReportDialog.ts";
import { Button, SxProps } from "@mui/material";
import { Theme } from "@mui/material/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { mergeSx } from "src/utils/styles.ts";

export interface OpenErrorReportDialogButtonProps {
	eventId: string;
	onClick?: () => void;
	sx?: SxProps<Theme>;
}

export const OpenErrorReportDialogButton = ({
	eventId,
	onClick,
	sx,
}: OpenErrorReportDialogButtonProps) => {
	return (
		// Keep this as a raw button. It is used by error UI, including ErrorBoundary fallback,
		// where AsyncButton/AavoButton cannot safely depend on ErrorDialogContext.
		<Button
			sx={mergeSx({ textTransform: "none" }, sx)}
			startIcon={<FontAwesomeIcon icon={faBullhorn} />}
			variant={"outlined"}
			onClick={() => {
				showErrorReportDialog(eventId);
				onClick?.();
			}}
		>
			{i18n.t("error_report")}
		</Button>
	);
};
